import { getFallbackValueIfNull } from 'owa-options-core';
import store from '../store/store';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().ViewStateConfiguration; },
})(function isAttachmentPreferencesOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    var fromComputer = getFallbackValueIfNull(optionState.fromComputer, userOptions.AttachOrShareLocalFiles);
    var fromOneDrive = getFallbackValueIfNull(optionState.fromOneDrive, userOptions.AttachOrShareCloudFiles);
    return (fromComputer !== userOptions.AttachOrShareLocalFiles ||
        fromOneDrive !== userOptions.AttachOrShareCloudFiles);
});
//# sourceMappingURL=isAttachmentPreferencesOptionDirty.js.map